<template lang="html">
  <Row :gutter="15">
    <Col :span="24">
    <Card class="card-box">
      <div slot="header" class="header-text mb-0">
        {{$t('DASHBOARD_UNLOADING_VS_ETA')}}
      </div>
      <div class="text-center"
        v-if="isUnloadingVsEtaNotReleaseVarianceLoading && isCountForTotalReportAndReleaseLoading">
        <Spinner />
      </div>
      <div class="status-msg" v-else-if="!unloadingVsEtaData">
        <span>
          <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
          <p class="mt-0 ml-30">{{$t('DASHBOARD_NO_DATA_AVAILABLE')}}</p>
        </span>
      </div>
      <Row :gutter="40" class="list-bordered" v-else>
        <Col v-for="header in unloadingVsEtaHeaders" :span="header.colSpan" :key="header.id" :class="header.class">
        <Tooltip :open-delay="100" popper-class="max-width" effect="dark" placement="top">
          <div slot="content">
            <span v-html="trackingDashboard[header.column2]"></span>
          </div>
          <ColCell :header="header" :value="getUnloadingVsEta(header)"
            @routeToTrack="$emit('routeToTrack', { routeCategory: header.routeCategory, header: $event })">
          </ColCell>
        </Tooltip>
        </Col>
      </Row>
    </Card>
    </Col>
  </Row>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import { isNumber, cloneDeep } from 'lodash';
import {
  unloadingVsEtaHeaders,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
  },
  mixins: [SecFilterMixin],
  created() {
    this.apiTrigger.$on('loadMore', (args) => {
      this.search();
    });
  },
  data() {
    return {
      unloadingVsEtaNotReleaseVariance: null,
      countForTotalReportAndRelease: null,
      unloadingVsEtaData: {},
      unloadingVsEtaHeaders,
      isUnloadingVsEtaNotReleaseVarianceLoading: true,
      isCountForTotalReportAndReleaseLoading: true,
    };
  },
  props: ['queryParams', 'apiTrigger', 'emptyDashboardIcon', 'trackingDashboard'],
  computed: {
    getUnloadingVsEta() {
      return (header) => {
        if (this.unloadingVsEtaData[header.column1]) {
          return isNumber(this.unloadingVsEtaData[header.column1][header.column2]) ? this.unloadingVsEtaData[header.column1][header.column2] : '';
        }
        return '';
      };
    },
  },
  methods: {
    async search() {
      const unloadingApiCall = [
        {
          resultObj: 'unloadingVsEtaNotReleaseVariance',
          loadingObj: 'isUnloadingVsEtaNotReleaseVarianceLoading',
          section: 'unloadingVsEtaNotReleaseVariance',
        },
        {
          resultObj: 'countForTotalReportAndRelease',
          loadingObj: 'isCountForTotalReportAndReleaseLoading',
          section: 'countForTotalReportAndRelease',
        },
      ];
      for (let i = 0; i < unloadingApiCall.length; i++) {
        const resultObj = unloadingApiCall[i].resultObj;
        const loadingObj = unloadingApiCall[i].loadingObj;
        const section = unloadingApiCall[i].section;
        const params = this.queryParams;
        this[loadingObj] = true;
        const result = await this.$store.dispatch('track/getDashboardDetails', { section, params });
        if (result && !result.error) {
          this[resultObj] = result;
        } else {
          this[resultObj] = null;
        }
        this[loadingObj] = false;
      }

      this.unloadingVsEtaData = cloneDeep({
        unloadingVsEtaNotReleaseVariance: this.unloadingVsEtaNotReleaseVariance,
        countForTotalReportAndRelease: this.countForTotalReportAndRelease
      });
    },
  },
};
</script>
